<template>
  <CContainer :fluid="true" class='order-modal p-3'>
      <CRow>
          <CCol class='col-12 text-center'>
              <h2>Notificación de compra</h2>
          </CCol>
          <CCol class='col-12'>
              <label for="textarea">Puede dejar aquí sus comentarios sobre la compra:</label>
              <CTextarea :value.sync='message' placeholder='Mensaje (Opcional)'></CTextarea>
          </CCol>
          <CCol class='col-12'>
              <CRow class='d-flex justify-content-sm-end'>
                    <CCol class='col-12 col-sm-auto'>
                        <CButton color='success' @click="setBuyedOrder(5)">
                            Compra completa
                        </CButton>
                    </CCol>
                    <CCol class='col-12 col-sm-auto'>
                        <CButton color='warning' @click="setBuyedOrder(9)">
                            Compra parcial
                        </CButton>
                    </CCol>
                    <CCol class='col-12 col-sm-auto'>
                        <CButton color='danger' @click="closeModal">
                            Cancelar
                        </CButton>
                    </CCol>              
                </CRow>
          </CCol>
      </CRow> 
  </CContainer>
</template>

<script>
export default {
    name: 'DeliveredOrderModal',
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            message: ''
        }
    },
    methods: {
        closeModal(){
            this.$root.$emit('close-modal')
        },
        setBuyedOrder(status_id){

            const data = {
                order_id: this.order.id,
                message: this.message,
                status_id: status_id
            }

            this.$api.orders.setBuyedOrder(data)
            .then(res => {
                this.$root.$emit('buyed-order');
            })
            .catch(error => {
                console.log(error)
            })
        }
    }
}
</script>

<style lang='scss'>
.order-modal{
    max-height: calc(100vh - 2rem);
    background-color: white;
    border-radius: 4px;
    max-width: 600px;
}
</style>